module.exports = __webpack_public_path__ + "media/images/brand/people02-bc30ee56a17491295f29f23006545ee7.png";